// extracted by mini-css-extract-plugin
module.exports = {"PageHolder":"Dashboard_PageHolder__28FpW","tabHolder":"Dashboard_tabHolder__1ihvp","onFocus":"Dashboard_onFocus__C2sek"};